import { isToday, parseISO, isBefore, getMinutes, isYesterday } from "date-fns";
import { format, utcToZonedTime } from "date-fns-tz";

export const calculateMeterExpirationDate = (date: Date) => {
  return new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth() + 1, 1));
};
/**
 * formatArticleDate creates the formatted date according to the following rules.
 * source: ArticleTimestamp date: today or yesterday not on the hour: September 21, 2021, 5:30 AM ET
 * source: ArticleTimestamp date: today or yesterday but on the hour: September 20, 2021, 5 AM ET
 * source: null, date: today: 5:45 PM ET
 * All other dates: September 10, 2021
 * @param date ISO Date string.
 * @returns Formatted date
 */
export const formatArticleDate = (
  date: string | null | undefined,
  location?: "ArticleTimestamp"
) => {
  if (!date) return "";
  const dateInstance = parseISO(date);
  const nyTimeZone = "America/New_York";
  const nyDate = utcToZonedTime(dateInstance, nyTimeZone);
  const recentlyPublished = isToday(nyDate) || isYesterday(nyDate);

  if (location == "ArticleTimestamp" && recentlyPublished) {
    const isOnTheHour = getMinutes(nyDate) == 0;
    if (isOnTheHour) return format(nyDate, "MMMM d, y, h a 'ET'");
    return format(nyDate, "MMMM d, y, h:mm a 'ET'");
  }

  if (isToday(nyDate)) {
    return format(nyDate, "h:mm a 'ET'");
  }

  return format(dateInstance, "MMMM d, y");
};

/**
   Confirms if a date is after the editorial cutoff for showing Magazine articles web
   publishing date.
  */
export const shouldRenderIssueName = (date: string | null | undefined) => {
  const CUTOFF_DATE = "2021-08-17";

  if (!date) return false;

  const articleDateInstance = parseISO(date);
  const beforeDateInstance = parseISO(CUTOFF_DATE);

  return isBefore(articleDateInstance, beforeDateInstance);
};

export const formatArticleUpdatedDate = (date: string | null | undefined) => {
  if (!date) return "";
  const dateInstance = parseISO(date);
  const nyTimeZone = "America/New_York";

  try {
    const nyDate = utcToZonedTime(dateInstance, nyTimeZone);
    const time = `${format(nyDate, "h:mm a", {
      timeZone: nyTimeZone,
    })} ET`;

    return isToday(dateInstance)
      ? time
      : `${time} on ${format(nyDate, "MMMM d, y", {
          timeZone: nyTimeZone,
        })}`;
  } catch (err) {
    console.error("'Updated at' timestamp err", err);
  }
};
